import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithHidden } from '~/core/styleTypes';

import { GameCenterComponentGridAreas, LinkedButton } from '../../styles';

const ASPECT_RATIO = 9 / 16;
const RECAP_HEIGHT = 458;

export const GameRecapContainer = styled.div`
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.gameRecap};
`;

export const Summary = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body1};
    margin-bottom: 24px;
`;

export const VideoContainer = styled.div<{ $isClickable: boolean }>`
    justify-content: center;
    cursor: ${({ $isClickable }) => $isClickable && 'pointer'};

    svg {
        width: 60px;
        height: 60px;
        fill: ${({ theme }) => theme.Surface.primary};
        position: relative;
        z-index: 1;
        bottom: 65px;
        left: 4px;
        margin-bottom: -90px;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        svg {
            width: 90px;
            height: 90px;
            fill: ${({ theme }) => theme.Surface.primary};
            position: relative;
            bottom: 100px;
            left: 10px;
        }
    }
`;

export const RecapImageContainer = styled.div<WithHidden>`
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'initial')};
`;

export const IconContainer = styled.div`
    display: flex;
    flex: 10;
`;

export const RecapImage = styled.img`
    max-height: ${RECAP_HEIGHT}px;
    max-width: 100%;
`;

export const LoadingRecapContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: ${RECAP_HEIGHT}px;
    max-width: 100%;
    min-height: min(100vh * ${ASPECT_RATIO}, 100vw);
`;

export const RecapLinkedButton = styled(LinkedButton)`
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 135px;
    }
`;

export const ArticleInformation = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.gaps.large}
        margin-bottom: 48px;
    }
`;

export const AuthorAndLinksContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    ${BaseStyle.Mixins.screenSizes.large} {
        flex-direction: row;
        justify-content: space-between;
        gap: initial;
        margin-bottom: 24px;
    }
`;

export const AuthorAndDate = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body2};
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.Text.primary};
`;

export const AuthorContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;
export const Author = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle2};
    margin-left: 4px;
`;

export const SecondaryTextContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.date};
    color: ${({ theme }) => theme.Text.secondary};
`;

export const ImageCaption = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.caption};
    margin-top: 8px;
    margin-bottom: 16px;

    ${BaseStyle.Mixins.screenSizes.large} {
        margin-bottom: 24px;
    }
`;
